export default "__VITE_PUBLIC_ASSET__33077b43__"